import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import useAccountDetailQuery from 'hooks/useAccountDetailQuery';
import useWorkshopQuery from 'hooks/useWorkshopQuery';

import { Workshop } from '../../api/types';

async function update(axios: AxiosInstance, workshop: Workshop, legalForm: string): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/workshop/${workshop.id}`, {
    firstname: workshop.firstname,
    lastname: workshop.lastname,
    email: workshop.email,
    billing_email: workshop.billing_email,
    telephone: workshop.telephone,
    name: workshop.name,
    vat_number: workshop.vat_number,
    legal_form: legalForm,
    address: workshop.address,
    city: workshop.city,
    zipcode: workshop.zipcode,
    disable_cost_control: workshop.disable_cost_control,
    language: workshop.language,
    distributor_id: workshop.distributor?.id ?? null,
    key_account: workshop.key_account,
  });
  return data;
}

export default function useUpdateWorkshopLegalFormMutation(accountId: number) {
  const queryClient = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: (params: { workshop: Workshop; legalForm: string }) => update(axios, params.workshop, params.legalForm),
    onSuccess: (_data, params) => {
      queryClient.invalidateQueries({ queryKey: useWorkshopQuery.getKey(params.workshop.id) });
      queryClient.invalidateQueries({ queryKey: useAccountDetailQuery.getKey(accountId) });
    },
  });
}
